import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProject = api(async function getProject({ projectId }) {
    if (!projectId) return null
    try {
        return await query(
            gql`
                query GetProject($projectId: String!) {
                    getProject(projectId: $projectId) {
                        id
                        _id
                        _modified
                        _created
                        name
                        internalDescription
                        sentToLegacy
                        phase
                        archived
                        archivedAt
                        archivedBy
                        scheduleIds
                        originalTaskIds
                        scopedScheduleIds
                        creator
                        groups {
                            id
                            name
                            type
                            status
                            readOnly
                            legislation
                            error
                            legacySendResults {
                                status
                                scheduleId
                                error
                            }
                            ... on AddGroup {
                                addTypeSchedules {
                                    id
                                    code
                                    title
                                }
                                newTasks {
                                    temporaryTaskId
                                    isHeader
                                    title
                                    classification
                                    content
                                    note
                                    componentRef
                                    linkedFields
                                    frequency {
                                        period
                                        interval
                                        label
                                    }
                                    skillSet
                                    minutes
                                    unitOfMeasure
                                }
                            }
                            ... on IntroductionGroup {
                                introTypeSchedules {
                                    id
                                    code
                                    title
                                }
                                intro
                            }
                            ... on LeadingSummaryGroup {
                                leadingSummaryTypeSchedules {
                                    id
                                    code
                                    title
                                }
                                leadingSummary
                                overwriteExisting
                            }
                            ... on OverwriteGroup {
                                sourceTask
                                sourceTaskId
                                scheduleId
                                originalTaskId
                                similarTasks {
                                    id
                                    task {
                                        unitOfMeasure
                                        minutes
                                        skill {
                                            CoreSkillingID
                                            SkillingCode
                                            Skilling
                                        }
                                        skillSet
                                        frequency {
                                            period
                                            interval
                                            label
                                        }
                                        taskId
                                        note
                                        content
                                        classification
                                        title
                                        id
                                        isHeader
                                    }
                                    scheduleId
                                    taskId
                                    fullStrength
                                    scheduleTitle
                                    scheduleCode
                                }
                            }
                        }
                    }
                }
            `,
            { projectId },
            { returns: "getProject" }
        )
    } catch {
        return null
    }
})
